import {Draggable, Droppable} from "react-beautiful-dnd"
import {ClockHoursTranscriptSubmodule} from "types/clock-hours-transcript"
import styles from "./CourseSubmoduleList.module.css"

type CourseSubmoduleListProps = {
    droppableId: string
    submodules: ClockHoursTranscriptSubmodule[]
}

export const CourseSubmoduleList = ({droppableId, submodules}: CourseSubmoduleListProps) => {
    if (!submodules.length) {
        return null
    }

    return (
        <Droppable droppableId={droppableId} type="submodule">
            {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps} className={styles.list}>
                    {submodules.map((submodule, index) => (
                        <Draggable
                            key={submodule.submoduleId}
                            draggableId={`${droppableId}-${submodule.submoduleId}`}
                            index={index}>
                            {(dragProvided, snapshot) => (
                                <div
                                    ref={dragProvided.innerRef}
                                    {...dragProvided.draggableProps}
                                    {...dragProvided.dragHandleProps}
                                    className={snapshot.isDragging ? styles.rowDragging : styles.row}
                                    style={dragProvided.draggableProps.style}>
                                    <span className={styles.title}>{submodule.title}</span>
                                    <span className={styles.quantity}>
                                        {submodule.quantity} {submodule.units}
                                    </span>
                                </div>
                            )}
                        </Draggable>
                    ))}
                    {provided.placeholder}
                </div>
            )}
        </Droppable>
    )
}
